const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

function hasConsent() {
  return localStorage.getItem('cookie_consent') === 'accepted'
}

export function initAnalytics() {
  if (hasConsent()) {
    enableAnalytics()
  }

  window.addEventListener('growlab:consentChanged', () => {
    if (hasConsent()) {
      enableAnalytics()
    }
  })
}

function enableAnalytics() {
  if (typeof gtag === 'undefined' || !GA_ID) return
  gtag('consent', 'update', { analytics_storage: 'granted' })
}

export function trackPageView(path) {
  if (!hasConsent() || typeof gtag === 'undefined' || !GA_ID) return
  gtag('event', 'page_view', {
    page_path: path,
    send_to: GA_ID,
  })
}

export function trackEvent(eventName, params = {}) {
  if (!hasConsent() || typeof gtag === 'undefined' || !GA_ID) return
  gtag('event', eventName, { send_to: GA_ID, ...params })
}

export function getUserSegment({ provisionedByReseller, subscriptionActive = false, trialTokensRemaining = 0 }) {
  if (provisionedByReseller) return 'reseller'
  if (subscriptionActive) return 'subscribed'
  if (trialTokensRemaining > 0) return 'trial'
  return 'expired'
}
